export default __webpack_public_path__ + "17- woman water bottle-middle-resized.34189b72b693c70a1799.png";